/**
 * @typedef {{
 * PVZ: object,
 * city: string,
 * cityName: string,
 * currency: string,
 * id: string, price: string,
 * tarif: number,
 * term: number
 * }} cdekInfo
 */

export default function SDEKmap() {
  try {
    if (document.querySelector('.cart-order') !== null) {
      // eslint-disable-next-line no-undef
      new CDEKWidget({ ...defaultMapConfig, ...orderMapConfig });
    } else {
      // eslint-disable-next-line no-undef
      new CDEKWidget(defaultMapConfig);
    }
  } catch (e) {
    // eslint-disable-next-line
    console.warn(e);
  }
}
// const test = async () => {
//   console.log('fff');
//   const cities = await getRegionByCityId(172);
//   console.log(cities);
//   debugger;
// };

const defaultMapConfig = {
  defaultLocation: 'Москва', // стандартный город на карте
  from: {
    city: 'Москва',
  }, // из какого города будет идти доставка
  country: 'Россия', // можно выбрать страну, для которой отображать список ПВЗ
  root: 'forpvz',
  apiKey: 'ae8004a9-eb18-4b6a-96ae-6df3914ffa53',
  servicePath: '/vendor/cdek/service.php', // ссылка на файл service.php на вашем сайте
};

const orderMapConfig = {
  region: true,
  hideDeliveryOptions: {
    office: false,
    door: true,
  },
  /**
   * @param {cdekInfo} info
   */
  onChoose(_, __, info) { // при выборе ПВЗ: запишем номер ПВЗ в текстовое поле и доп. информацию
    const modal = document.querySelector('#forpvz').closest('.modal');
    showAlert(`Вы выбрали пункт выдачи по адресу ${info.name}`);
    insertData(info);
    $(modal).modal('hide');
  },
};

const alertTemp = text => '<div class="alert alert-danger" role="alert">\n'
  + `  ${text}\n`
  + '</div>';

const showAlert = (text) => {
  const alert = document.createElement('div');
  alert.innerHTML = alertTemp(text);
  alert.classList.add('time-alert');
  document.body.appendChild(alert);
  $(alert).fadeIn(400);

  setTimeout(() => {
    $(alert).fadeOut(400);
  }, 3500);
};

/**
 * @param {cdekInfo} info
 */
const insertData = async (info) => {
  const form = window.parent.document.querySelector('#step-4 form');
  const [address, house] = info.address.split(',');
  form.region.value = '';
  form.city.value = NonUndefinedString(info.city);
  form.address.value = NonUndefinedString(address);
  form.house.value = NonUndefinedString(house);
};

/**
 * @param string
 * @returns {string}
 */
const NonUndefinedString = string => ((string !== undefined) ? string : '');
